import { isEmpty, isNil } from 'lodash';
import { Observable } from 'rxjs/Observable';

import { esbApi } from '@modules/rtk/esb-api';

/**
 * @esbEndpoint GET /organizations/v2/:orgGuid/profile
 */
const getUnitInfo$ = (
  guid,
  /** @type {import('@reduxjs/toolkit').ThunkDispatch} */
  dispatch,
) => {
  if (isNil(guid) || isEmpty(guid)) {
    return Observable.of({});
  }

  const thunk = dispatch(
    esbApi.endpoints.getOrganizationProfile.initiate({
      orgGuid: guid,
    }),
  ).then(result => result.data);
  return Observable.fromPromise(thunk);
};

export default {
  getUnitInfo$,
};
